import {useTheme} from '@mui/material';
import Container from '@mui/material/Container';
import type * as React from 'react';

type Props = {
    maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
    children: React.ReactNode;
};

const PaddedContainer: React.FC<Props> = ({children, maxWidth}: Props) => {
    const theme = useTheme();

    return (
        <Container
            maxWidth={maxWidth ?? 'md'}
            sx={{
                paddingTop: theme.spacing(3),
                paddingBottom: theme.spacing(3),
            }}
        >
            {children}
        </Container>
    );
};

export default PaddedContainer;
